export default "__VITE_ASSET__BQTH5E2S__"